import * as React from "react";
import { ITransaction } from "../../../../config/transactions";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Section } from "../Components/Section";
import { detailsAutomaticDisplayFields } from "../../../../config/transaction_details";
import TagIcon from '@mui/icons-material/Tag';
import { IAttachment } from "../../../../config/attachments";
import { Tags } from "./Tags";

interface IExtrasProps {
    transaction: ITransaction;
    attachments: IAttachment[];
}

const ExtrasSectionWrapper = ({children}: any) => {
    const isSmallScreen = useMediaQuery(useTheme().breakpoints.only('xs'));

    if (isSmallScreen) {
        return (
            <Grid size={{ xs: 12 }}>
                {children}
            </Grid>
        )
    }

    return <Box>{children}</Box>;
};

export const Extras = ({transaction, attachments}: IExtrasProps) => {
    const standards = !!transaction.details ?
        Object
            .keys(transaction.details)
            .filter(k => (transaction.details as any)[k] !== undefined)    
            .filter(k => detailsAutomaticDisplayFields[k] !== undefined)
            .filter(k => detailsAutomaticDisplayFields[k].type === 'standard') : [];

    const standalones = !!transaction.details ?
        Object
        .keys(transaction.details)
        .filter(k => (transaction.details as any)[k] !== undefined)    
        .filter(k => detailsAutomaticDisplayFields[k] !== undefined)
        .filter(k => detailsAutomaticDisplayFields[k].type === 'standalone') : [];

    return (
        <>
            {!!standards.length && (
                <ExtrasSectionWrapper>
                    <Section title="Extras" sections={standards.map(k => {
                        const item = detailsAutomaticDisplayFields[k];
                        
                        const Component = detailsAutomaticDisplayFields[k].component;
                        const Icon = detailsAutomaticDisplayFields[k].icon;
        
                        return {
                            title: item.label,
                            value: !!Component ? <Component value={(transaction.details as any)[k]} transaction={transaction} /> : (transaction.details as any)[k],
                            icon: <Icon />,
                        };
                    }) as any} />
                </ExtrasSectionWrapper>
            )}

            {!!standalones.length && (
                standalones.map((k, index) => {
                    const item = detailsAutomaticDisplayFields[k];
                    const Component = item.component;

                    return (
                        <ExtrasSectionWrapper key={index}>
                            <Component value={(transaction.details as any)[k]} transaction={transaction} attachments={attachments} />
                        </ExtrasSectionWrapper>
                    );
                })
            )}

            {!!transaction.tags?.length && (
                <ExtrasSectionWrapper>
                    <Section title="Tags" sections={[
                        {
                            value: <Tags tags={transaction.tags} />,
                            icon: <TagIcon />,
                        }
                    ]} />
                </ExtrasSectionWrapper>
            )}
        </>
    )
};
